@if (displayedTag()) {
  <oui-tag
    type="status"
    [size]="size()"
    [status]="$safeNavigationMigration(displayedTag()?.tagStatus)">
    {{ displayedTag()?.label }}
  </oui-tag>
}
